import React from 'react';
export default function DiIconTick(props) {
  return React.createElement(
    'svg',
    {
      viewBox: '0 0 18 14'
    },
    React.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd'
      },
      React.createElement('path', {
        d: 'M5.44056549,12.9535843 L17.1520015,1.24218645 C17.3350302,1.05911956 17.3350302,0.762336821 17.1520015,0.579231789 L16.7100317,0.137300164 C16.527003,-0.0457667213 16.2302202,-0.0457667213 16.0471534,0.137300164 L5.10910723,11.0753463 L1.24211969,7.20835874 C1.0590528,7.02533001 0.762270064,7.02533001 0.579203178,7.20835874 L0.137271554,7.65029037 C-0.0457571846,7.83331911 -0.0457571846,8.13013999 0.137271554,8.31320688 L4.77764898,12.9535843 C4.96071586,13.1366512 5.2574986,13.1366512 5.44056549,12.9535843 Z',
        fill: '#303030',
        fillRule: 'nonzero'
      })
    )
  );
}